import { Link } from "@tanstack/react-router";
import { EditorialImage } from "./EditorialImage";
import { cn } from "@/lib/utils";

type Props = {
  title: string;
  caption?: string;
  to: string;
  image?: string;
  className?: string;
  /** Override object-position for this card (e.g. "object-[50%_60%]"). */
  imagePosition?: string;
  /** Show a "Nouveau" badge on the card. */
  isNew?: boolean;
};

export function CollectionCard({
  title,
  caption,
  to,
  image,
  className,
  imagePosition,
  isNew,
}: Props) {
  return (
    <Link
      to={to}
      className={cn(
        "group relative block aspect-[3/4] overflow-hidden bg-sand shadow-card ring-1 ring-border",
        className,
      )}
    >
      {/* Image en remplissage absolu : le ratio fixe du parent réserve la hauteur */}
      <EditorialImage
        src={image}
        alt={title}
        ratio="portrait"
        label={`${title} — photo éditoriale`}
        className="absolute inset-0 h-full w-full"
        imageClassName={cn("h-full w-full", imagePosition)}
        sizes="(min-width: 1024px) 33vw, 50vw"
        hideLabel
      />

      {/* Overlay identique sur mobile, tablette et desktop */}
      <div className="card-overlay" aria-hidden="true" />
      <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
        {isNew ? (
          <span className="card-badge label-xs mb-2 text-[0.5rem] tracking-[0.22em] sm:text-[0.55rem]">
            <span
              className="card-badge-dot motion-safe:animate-[pulse_2.8s_cubic-bezier(0.4,0,0.6,1)_infinite]"
              aria-hidden="true"
            />
            Nouveau
          </span>
        ) : null}

        <h3 className="font-serif text-lg italic leading-tight text-onmedia sm:text-xl lg:text-2xl [text-shadow:0_1px_12px_rgba(0,0,0,0.35)]">
          {title}
        </h3>
        {caption ? (
          <p className="label-xs mt-1.5 hidden text-[0.55rem] text-onmedia/85 sm:block [text-shadow:0_1px_8px_rgba(0,0,0,0.35)]">
            {caption}
          </p>
        ) : null}
      </div>
    </Link>
  );
}
